import { createTheme } from "@mui/material/styles";

// Same colors config from _variables.scss
const colors = {
  primaryPurple: "#FB4764",
  primaryPink: "#FBCEB1",
  primaryBlue: "#FB4764",
  background: "#ffff;",
  white: "#FFFFFF",
  inactive: "#b4a9a9",
  lightOrange: "#F4DAD6",
  lightPink: "#F6F3F4",
  softPink: "#FB47644D",
  lightBrown: "  #FB4764CC",
  dark: "#171717",
  gray: "#646666",
  darkGray: "#171717",
  error: "#B3261E",
  disabled: "#b3b3b3",
  body: "#8B96A6",
  placeHolder: "#C0C7D1",
  lightBlue: "#DFE9F7",
  mediumBlue: "#B9D3FA",
  deepBlue: "#6DA2F2",
  success: "#5CE57A",
  purple: "#7051A4",
  new: "#FFFFC2",
};

const theme = createTheme({
  palette: {
    primary: {
      main: colors.primaryPurple,
      light: colors.lightOrange,
      contrastText: colors.white,
    },
    secondary: {
      main: colors.primaryPink,
      contrastText: colors.primaryPurple,
    },
    background: {
      default: colors.background,
      paper: colors.white,
    },
    text: {
      primary: colors.dark,
      secondary: colors.body,
      disabled: colors.inactive,
    },
    error: {
      main: colors.error,
    },
    success: {
      main: colors.success,
    },
    grey: {
      100: colors.disabled,
      200: colors.placeHolder,
      300: colors.gray,
      400: colors.darkGray,
    },
    action: {
      disabled: colors.disabled,
      active: colors.primaryPurple,
    },
    info: {
      main: colors.deepBlue,
      light: colors.lightBlue,
    },
    custom: {
      ...colors, // Add all colors to a custom namespace for direct access
    },
  },
  typography: {
    fontFamily: [
      "Inter",
      "Poppins",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      "Oxygen",
      "Ubuntu",
      "Cantarell",
      '"Fira Sans"',
      '"Droid Sans"',
      '"Helvetica Neue"',
      "sans-serif",
    ].join(","),
    button: {
      textTransform: "none",
      fontFamily: "Inter, sans-serif",
    },
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: "Inter, sans-serif",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "Inter, sans-serif",
        },
      },
    },
  },
});

export default theme;
